<template>
  <svg
    class="delete-line"
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.5 1.00049H16.5V4.00049H22V6.00049H19.971L19.471 23.0005H4.52898L4.02898 6.00049H2V4.00049H7.5V1.00049ZM9.5 4.00049H14.5V3.00049H9.5V4.00049ZM6.02984 6.00049L6.47102 21.0005H17.529L17.9702 6.00049H6.02984ZM13 8.00049V19.0005H11V8.00049H13Z"
      fill="#595959"
    />
  </svg>
</template>

<script>
export default {
  name: 'UQueryExampleDelete'
};
</script>
